module.exports = __webpack_public_path__ + "assets/47.jpg?0c0824c5f55a1dc906357f5aa8530856";